import type { IGetListParams } from '../types/index';

export const RoadmapApi = Symbol('RoadmapApi');

export interface RoadmapApi {
    previewMeta(meta: any): Promise<{
        group: number,
        number: number
    }>;
    create(title: string, meta: any): Promise<string>;
    update(roadMapId: string, meta: any): Promise<unknown>;
    delete(roadMapId: string): Promise<unknown>;
    init(): Promise<number>;
    getList(params?: IGetListParams): Promise<unknown>;
}
